/* eslint-disable react-refresh/only-export-components */
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

type LexiqueContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const LexiqueContext = createContext<LexiqueContextValue | null>(null);

export function LexiqueProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const value = useMemo<LexiqueContextValue>(() => ({ isOpen, open, close }), [isOpen, open, close]);
  return <LexiqueContext.Provider value={value}>{children}</LexiqueContext.Provider>;
}

export function useLexique(): LexiqueContextValue {
  const ctx = useContext(LexiqueContext);
  if (!ctx) throw new Error('useLexique must be used inside <LexiqueProvider>.');
  return ctx;
}
